module.exports = __webpack_public_path__ + "static/media/Michael2021.a6288eb1.png";